// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 502 ? "d2c86127" : chunkId) + "." + {"502":"cde85a7db044c928","604":"23515f98a4e58629"}[chunkId] + ".js";
};